import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClienteComponent } from './cliente/cliente.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { InvoiceUpdComponent } from './invoice-upd/invoice-upd.component';
import { ListaFacturasComponent } from './lista-facturas/lista-facturas.component';
import { ListaComponent } from './lista/lista.component'
import { ProductoComponent } from './producto/producto.component';
import { ListaImportacionComponent } from './lista-importacion/lista-importacion.component';
import { TableroComponent } from './tablero/tablero.component';
import { ImportInvoicesComponent } from './import-invoices/import-invoices.component';

const routes: Routes = [
  {
    path: 'home',
    component: ListaComponent,
  },
  {
    path: 'nueva/:tipo',
    component: InvoiceComponent
  },
  {
    path: 'editar/:tipo',
    component: InvoiceUpdComponent
  },
  {
    path: 'clientes',
    component: ClienteComponent
  },
  {
    path: 'productos',
    component: ProductoComponent
  },
  {
    path: 'facturas/:anio/:mes/:rfc/:lugar/:tipo/:status/:metodo/:busqueda',
    component: ListaFacturasComponent
  },
  {
    path: 'dashboard',
    component: TableroComponent
  },
  {
    path: 'recuperacion',
    component: ListaImportacionComponent
  },
  ,
  {
    path: 'importar',
    component: ImportInvoicesComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FacturaRoutingModule { }
